import { createSelector } from 'reselect';

export const getComponentState = state => state.adminHelpDesk;

export const getRequests = createSelector(
    getComponentState,
    (state) => state.requests
);
export const getFetching = createSelector(
    getComponentState,
    (state) => state.fetching
);
export const getIdModal = createSelector(
    getComponentState,
    (state) => state.idModal
);
export const getSending = createSelector(
    getComponentState,
    (state) => state.sending
);
export const getPagination = createSelector(
    getComponentState,
    (state) => state.pagination
);
export const getRequest = createSelector(
    getComponentState,
    (state) => state.request
);
export const getSort = createSelector(
    getComponentState,
    (state) => state.sort
);
export const getSearch = createSelector(
    getComponentState,
    (state) => state.search
);
export const getSearchType = createSelector(
    getComponentState,
    (state) => state.searchType
);
export const getResponseMessage = createSelector(
    getComponentState,
    (state) => state.responseMessage
);
export const getClosingTicket = createSelector(
    getComponentState,
    (state) => state.closingTicket
);